<template>
    <div class="wrap-content">
        <div class="filter-section alert-filter row-min-space">
            <div class="row">
                <div class="col-md-12">
                    <h2>Alerts</h2>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row">
                                <div class="col-xs-12 col-md-3 tabs-bar">
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="query.status"
                                            :options="options"
                                            buttons
                                            button-variant="outline-primary"
                                            :name="filterName"
                                            @change="filterTab()"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </div>
                                <div class="col-xs-12 col-md-9">
                                    <div class="row">
                                        <div class="col-xs-12 col-md-3">
                                            <base-search
                                                placeholder="Search"
                                                @keyword="getKeyword"
                                            ></base-search>
                                        </div>
                                        <div class="col-xs-12 col-md-3">
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-3"
                                                    v-model="query.type"
                                                    class="form-control"
                                                    :options="
                                                        filterAlertOptions
                                                    "
                                                    required
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-xs-12 col-md-3">
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-4"
                                                    v-model="query.riskLevel"
                                                    class="form-control"
                                                    :options="
                                                        filterRiskLevelOptions
                                                    "
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-xs-12 col-md-3">
                                            <b-form-group>
                                                <b-form-select
                                                    id="input-5"
                                                    v-model="query.aging"
                                                    class="form-control"
                                                    :options="
                                                        filterAgingOptions
                                                    "
                                                ></b-form-select>
                                            </b-form-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <div class="form-group">
                                <button
                                    class="btn btn-primary"
                                    :class="
                                        loading && showPageLoader
                                            ? 'disabled'
                                            : ''
                                    "
                                    type="submit"
                                    @click="apply()"
                                >
                                    <span class="btn-text">Apply</span>
                                    <span class="loader"></span>
                                </button>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <b-form-group>
                                <b-button
                                    type="button"
                                    variant="secondary"
                                    class="secondary-add-btn"
                                    @click="exportRecords"
                                >
                                    <span class="btn-text">EXPORT</span>
                                </b-button>
                            </b-form-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            :class="[
                'table-section',
                'table-min-width',
                'alert-custom-table',
                {
                    'overflow-hidden': !data.length && !showPageLoader,
                },
            ]"
        >
            <!-- Main table -->
            <b-table
                :items="data"
                :fields="alertsFields"
                no-local-sorting
                @sort-changed="sortingChanged"
                @row-clicked="CustomerProfile"
            >
                <!-- Alerts riskLevel -->

                <template slot="riskLevel" slot-scope="data">
                    <div
                        v-b-tooltip.hover
                        class="bar-line"
                        :class="data.item.riskRatingStatus"
                        :title="
                            (data.item.riskRatingStatus + ' Risk') | capitalize
                        "
                    ></div>
                    <div class="indecation">
                        <div class="alert-type-icons">
                            <span
                                v-show="data.item.isReturned"
                                class="alert-return-icon"
                            >
                                <i class="icon-chevron-down rotate"></i>
                                <i class="icon-chevron-down"></i>
                            </span>
                            <i
                                v-if="data.item.type == 'triggered'"
                                v-b-tooltip.hover
                                class="icon-flag"
                                :title="
                                    data.item.isReturned
                                        ? 'Trigger Return Alert'
                                        : 'Trigger Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'periodic'"
                                v-b-tooltip.hover
                                class="icon-rotate-inverse"
                                :title="
                                    data.item.isReturned
                                        ? 'Periodic Return Alert'
                                        : 'Periodic Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'on_boarding'"
                                v-b-tooltip.hover
                                class="icon-star"
                                :title="
                                    data.item.isReturned
                                        ? 'Onboarding Return Alert'
                                        : 'Onboarding Alert'
                                "
                            ></i>
                            <i
                                v-if="data.item.type == 'manual'"
                                v-b-tooltip.hover
                                class="icon-manual-alert"
                                :title="' Manual alert '"
                            ></i>
                        </div>
                    </div>
                </template>
                <!-- Alerts Type -->

                <!-- Aging -->
                <template slot="createdAt" slot-scope="data">
                    <span :class="agingClass(data.value)">
                        {{ agingFilter(data.value) }}
                    </span>
                </template>

                <!-- Alert Customer Id -->
                <!-- <template slot="idenfoId" slot-scope="data">
                    {{ data.value }}
                </template> -->

                <!-- Alert Nationality -->
                <template
                    v-if="data.item.customer"
                    slot="customer.nationality"
                    slot-scope="data"
                >
                    <div
                        v-for="(alertNationality, index) in data.item &&
                        data.item.customer &&
                        data.item.customer.nationality"
                        :key="index"
                    >
                        {{ customer.basicInfo.nationality }}
                    </div>
                </template>

                <template slot="profile" slot-scope="data">
                    <div class="profile-area">
                        <div
                            v-if="
                                data.item.customer &&
                                data.item.customer.documentInfo &&
                                data.item.customer.documentInfo.picture &&
                                data.item.customer.documentInfo.picture
                                    .fileName != ''
                            "
                            v-authenticated-image="
                                'customers/' +
                                data.item.customer.documentInfo.picture.fileName
                            "
                            class="profile-pic"
                        ></div>
                        <div
                            v-else
                            class="profile-pic"
                            :style="{
                                'background-image':
                                    'url(' +
                                    require('@/assets/images/dummy/dummy-user.png') +
                                    ')',
                            }"
                        ></div>
                    </div>
                </template>

                <!-- Alert Name Screening Status -->
                <template slot="nameScreeningStatus" slot-scope="data">
                    <name-screening-status :status-type="data.value">
                    </name-screening-status>
                </template>

                <!-- Alert Documentation Status -->
                <template slot="documentationStatus" slot-scope="data">
                    <alert-type-status
                        :status-type="data.value"
                    ></alert-type-status>
                </template>

                <!-- Alert Risk Rating Status -->
                <template slot="riskRatingStatus" slot-scope="data">
                    <alert-type-status
                        :status-type="alertStatus(data)"
                    ></alert-type-status>
                </template>

                <!-- Alert Status -->
                <template slot="data" slot-scope="data">
                    <div class="action-review">
                        <base-action
                            v-if="
                                data.item.status == 'locked' &&
                                hasScopes('unlock-alerts')
                            "
                            v-b-tooltip.hover
                            icon="icon-lock_outline"
                            class="disable-color"
                            label="Unlock"
                            :title="
                                data.item.user &&
                                'In Review by' +
                                    ' ' +
                                    data.item.user.firstName +
                                    ' ' +
                                    data.item.user.lastName
                            "
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('initiate-review-popup')
                            "
                        ></base-action>
                        <base-action
                            v-if="
                                data.item.status == 'locked' &&
                                !hasScopes('unlock-alerts')
                            "
                            v-b-tooltip.hover
                            icon="icon-lock_outline"
                            class="disable-color"
                            label="In Review"
                            :title="
                                data.item.user &&
                                'In Review by' +
                                    ' ' +
                                    data.item.user.firstName +
                                    ' ' +
                                    data.item.user.lastName
                            "
                        ></base-action>
                        <base-action
                            v-if="data.item.status == 'pending'"
                            :css-class="
                                hasScopes('kyc-status-review') &&
                                (hasScopes('maker') ||
                                    hasScopes('checker') ||
                                    hasScopes('approver'))
                                    ? ''
                                    : 'action-review disabled'
                            "
                            icon="icon-review"
                            label="Review"
                            @click="
                                selectedRecord(data.item)
                                $bvModal.show('initiate-review-popup')
                            "
                        ></base-action>
                    </div>
                </template>
            </b-table>
            <!-- When data is loading -->
            <base-table-spinner
                v-if="!data.length && showPageLoader"
            ></base-table-spinner>
            <!-- When record not found -->
            <base-no-record-found
                v-if="!data.length && !showPageLoader"
            ></base-no-record-found>
        </div>
        <base-records
            path="alerts/"
            :query="query"
            :reset="reset"
            :show-pagination="true"
        ></base-records>
        <initiate-review-popup></initiate-review-popup>
        <export-process-popup-old
            :id="id"
            title="Export Insight Alert's Data"
            :url="cancelUrl"
        ></export-process-popup-old>
    </div>
</template>

<script>
/* VUE STORE GETTER */
import { mapGetters } from 'vuex'
import _ from 'lodash'

/* REQUIRE MOMENT */
var moment = require('moment')
/* PROJECT COMPONENTS */
import alertTypeStatus from '@/components/BaseAlertType.vue'
import initiateReviewPopup from '@/components/popups/InitiateReviewPopup.vue'
import exportProcessPopupOld from '@/components/popups/ExportProcessPopupOld.vue'
import nameScreeningStatus from '@/components/NameScreeningStatus.vue'
import request from '@/utils/request'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        initiateReviewPopup,
        alertTypeStatus,
        nameScreeningStatus,
        exportProcessPopupOld,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPagination: false,
            showReviewLink: false,
            filterAging: '',

            image: 'dummy/dummy-user.png',

            alertsFields: [
                {
                    key: 'riskLevel',
                    label: 'Type',
                    sortable: true,
                    class: 'min-20',

                    formatter: (value) => {
                        return _.startCase(value)
                    },
                },
                {
                    key: 'profile',
                    label: '',
                    class: 'profile-absolute',
                },
                {
                    key: 'idenfoId',
                    label: 'CUSTOMER',
                    sortable: true,
                },
                {
                    key: 'customerName',
                    label: 'FULL NAME',
                    sortable: true,
                    // formatter: (value) => {
                    //     if (value) {
                    //         return _.startCase(
                    //             value.firstName +
                    //                 ' ' +
                    //                 value.middleName +
                    //                 ' ' +
                    //                 value.lastName
                    //         )
                    //     }
                    // },
                },
                {
                    key: 'customer.basicInfo.nationality',
                    label: 'NATIONALITY',
                    sortable: false,
                },
                {
                    key: 'createdAt',
                    label: 'Aging',
                    sortable: true,
                },
                {
                    key: 'nameScreeningStatus',
                    label: 'NAME SCREENING',
                    thClass: 'with-icon person-icon text-center',
                    tdClass: 'text-center',
                },
                {
                    key: 'documentationStatus',
                    label: 'DOCUMENTATION',
                    thClass: 'with-icon document-icon text-center',
                    tdClass: 'text-center',
                },
                {
                    key: 'riskRatingStatus',
                    label: 'RISK RATING',
                    thClass: 'with-icon text-center graph-icon',
                    tdClass: 'text-center',
                },
                {
                    key: 'data',
                    label: 'STATUS',
                    class: 'action',
                    thClass: 'w-120px',
                    sortable: true,
                },
            ],
            query: {
                keyword: '',
                perPage: 10,
                startAt: 1,
                sortBy: 'customerId',
                sortOrder: 'desc',
                riskLevel: null,
                status: null,
                dataSegmentId: null,
                aging: null,
                type: null,
            },
            reset: new Date().getTime(),
            items: [],
            options: [
                { text: 'All', value: null },
                { text: 'Pending', value: 'pending' },
                { text: 'In Review', value: 'locked' },
            ],
            filterName: null,
            filterByAlert: null,
            filterAlertOptions: [
                { text: 'Filter by alert type', value: null },
                { text: 'Trigger alert', value: 'triggered' },
                { text: 'Periodic alert', value: 'periodic' },
                { text: 'Manual alert', value: 'manual' },
                { text: 'Onboarding alert', value: 'on_boarding' },
            ],
            filterByRiskLevel: null,
            filterRiskLevelOptions: [
                { text: 'Filter by risk level', value: null },
                { text: 'High Risk', value: 'high' },
                { text: 'Medium Risk', value: 'medium' },
                { text: 'Low Risk', value: 'low' },
                { text: 'Sanctioned Risk', value: 'sanction' },
            ],
            filterByAging: null,
            filterAgingOptions: [
                { text: 'Filter by aging', value: null },
                { text: '0-30 days', value: '0-30' },
                { text: '31-60 days', value: '31-60' },
                { text: '61-90 days', value: '61-90' },
                { text: '91+ days', value: '91+' },
            ],
            alertlist: [],
            id: null,
            cancelUrl: 'insights/cancel-export',
        }
    }, // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'data',
            'showPageLoader',
            'loading',
            'reload',
            'alertsFilteredData',
            'kycRole',
            'hasScopes',
            'dataSegmentId',
        ]),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        reload(value) {
            if (value) {
                // this.reset = new Date().getTime()
            }
        },
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        // console.log("after alert", this.$store.getters.getField('pagination'))
        localStorage.setItem('goBackUrl', this.$route.name)
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async CustomerProfile(record) {
            await this.$store.commit('setAlertRecord', record)
            await localStorage.setItem('alertId', record._id)

            await this.$router.push({
                name: 'customer-information',
                params: {
                    id: record.customerId,
                },
            })
        },
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        }, // End of apply() method

        filterTab() {
            this.reset = new Date().getTime()
        }, // End of filterTab() method

        selectedRecord(record) {
            this.$store.commit('setAlertRecord', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            if (this.query.sortBy) {
                this.apply()
            }
        }, // End of sortingChanged() method

        agingFilter(value) {
            var currentDate = moment()
            var b = moment(value)
            return currentDate.diff(b, 'days') + ' D'
        },
        agingClass(value) {
            var currentDate = moment()
            var b = moment(value)
            let diff = currentDate.diff(b, 'days')
            if (diff <= 30) {
                return 'low'
            }
            if (diff > 30 && diff <= 60) {
                return 'medium'
            }
            if (diff > 60 && diff <= 90) {
                return 'danger'
            }
            if (diff > 90) {
                return 'high'
            }
        },
        imageFilePath(data) {
            if (data && data.picture && data.picture.fileName) {
                return 'customers/' + data.picture.fileName
            }
            return require('@/assets/images/dummy/dummy-user.png')
        },
        alertStatus(data) {
            if (data.item.customer && data.item.customer.diligenceStatus) {
                let nextReviewDate = this.$moment(
                    data.item.customer.diligenceStatus.nextReview
                )
                let diff = nextReviewDate.diff(this.$moment(), 'days')
                if (diff <= 60) {
                    return 'periodic_review_due'
                }
            }
            return data.value
        },
        //  exportRecords() {
        //     // this.$bvModal.show('export-process-popup')
        //
        // }, // End of exportRecords() method

        /**
         *
         * @return {void}
         */
        async exportRecords() {
            try {
                this.query.dataSegmentId = this.dataSegmentId

                let { data } = await request.post('alerts/export', null, {
                    params: this.query,
                })

                // console.log('data  ' + JSON.stringify(data))

                this.id = data.data.id
                this.$bvModal.show('export-process-popup-old')
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                // console.log(error, 'error')
            }
        }, // End of exportRecords() method
    }, // End of Component > methods
} // End of export default
</script>
